"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSection = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../themes/colors");
var setBorder = function (_a) {
    var props = _a.props;
    var borderStyles = '';
    var greyColor15 = colors_1.colors.greyColor15;
    if (props.borderTop || props.borderRight || props.borderLeft || props.borderBottom) {
        if (props.borderTop)
            borderStyles += "border-top: 1px solid ".concat(greyColor15, ";");
        if (props.borderLeft)
            borderStyles += "border-left: 1px solid ".concat(greyColor15, ";");
        if (props.borderRight)
            borderStyles += "border-right: 1px solid ".concat(greyColor15, ";");
        if (props.borderBottom)
            borderStyles += "border-bottom: 1px solid ".concat(greyColor15, ";");
    }
    return borderStyles;
};
var setFill = function (_a) {
    var _b;
    var props = _a.props;
    var colorsObj = ((_b = props.theme) === null || _b === void 0 ? void 0 : _b.colors) ? __assign(__assign({}, colors_1.colors), props.theme.colors) : colors_1.colors;
    var colorKey = Object.keys(props).find(function (p) { return !!colorsObj[p]; });
    return colorKey ? "background-color: ".concat(colorsObj[colorKey], ";") : '';
};
exports.StyledSection = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (props) { return setBorder({ props: props }); }, function (props) { return setFill({ props: props }); });
var templateObject_1;
